import LoadingAnalysis from './LoadingAnalysis';
import ProgressChart from './ProgressChart';
import ResultSummary from './ResultSummary';

/** Quiz blocks by element key, for registering with the form library. */
export const QUIZ_BLOCK_COMPONENTS: Record<string, React.ComponentType<any>> = {
  LoadingAnalysis,
  ResultSummary,
  ProgressChart,
};
